export const IndexedDBStores = {
  'key-value': '',
  'to-do': 'id,done',
  //dontRemove
} as const;
